export default "__VITE_ASSET__BASIe1vM__"